import { match } from 'ts-pattern'

import { Text, Skeleton, Flex } from '@sequencehq/core-components'
import { PricingModel } from 'common/drawers/PricingEditor/domain'
import { StandardPriceVariantForm } from '../../editors/StandardPrice/StandardPriceVariantForm'
import { GraduatedPriceForm } from '../../editors/GraduatedPrice/GraduatedPriceForm'
import { GraduatedPriceVariantForm } from '../../editors/GraduatedPrice/GraduatedPriceVariantForm'
import { LinearPriceVariantForm } from '../../editors/LinearPrice/LinearPriceVariantForm'
import { VolumePriceVariantForm } from '../../editors/VolumePrice/VolumePriceVariantForm'
import { PackagedPriceVariantForm } from '../../editors/PackagedPrice/PackagedPriceVariantForm'
import { SeatBasedPriceVariantForm } from '../../editors/SeatBasedPrice/SeatBasedPriceVariantForm'
import { StandardPriceForm } from '../../editors/StandardPrice/StandardPriceForm'
import { LinearPriceForm } from '../../editors/LinearPrice/LinearPriceForm'
import { VolumePriceForm } from '../../editors/VolumePrice/VolumePriceForm'
import { PackagedPriceForm } from '../../editors/PackagedPrice/PackagedPriceForm'
import { SeatBasedPriceForm } from '../../editors/SeatBasedPrice/SeatBasedPriceForm'
import { GreyGrey90 } from '@sequencehq/core-components'

type Props = {
  loading: boolean
  pricingModel: PricingModel
  isListPriceBasedVariant: boolean
  /**
   * When not a listy based priced variant, show the default title
   */
  showTitle?: boolean
}

const Title = () => (
  <Text color={GreyGrey90} fontWeight="bold" fontSize="l" mb="6">
    Pricing Information
  </Text>
)
export const VariantPriceLayoutContent = ({
  loading,
  pricingModel,
  isListPriceBasedVariant,
  showTitle = true
}: Props) => {
  if (loading) {
    return (
      <Flex direction="column" gap="20px" width="100%">
        <Skeleton height="40px" width="100%" />
        <Skeleton height="200px" width="100%" />
        <Skeleton height="40px" width="100%" />
        <Skeleton height="40px" width="100%" />
        <Skeleton height="40px" width="100%" />
      </Flex>
    )
  }

  return (
    <>
      {showTitle && !isListPriceBasedVariant && <Title />}
      {match(pricingModel)
        .with('STANDARD', () =>
          isListPriceBasedVariant ? (
            <StandardPriceVariantForm />
          ) : (
            <StandardPriceForm />
          )
        )
        .with('GRADUATED', () =>
          isListPriceBasedVariant ? (
            <GraduatedPriceVariantForm />
          ) : (
            <GraduatedPriceForm />
          )
        )
        .with('LINEAR', () =>
          isListPriceBasedVariant ? (
            <LinearPriceVariantForm />
          ) : (
            <LinearPriceForm />
          )
        )
        .with('VOLUME', () =>
          isListPriceBasedVariant ? (
            <VolumePriceVariantForm />
          ) : (
            <VolumePriceForm />
          )
        )
        .with('PACKAGE', () =>
          isListPriceBasedVariant ? (
            <PackagedPriceVariantForm />
          ) : (
            <PackagedPriceForm />
          )
        )
        .with('SEAT_BASED_GRADUATED', 'SEAT_BASED_LINEAR', () =>
          isListPriceBasedVariant ? (
            <SeatBasedPriceVariantForm />
          ) : (
            <SeatBasedPriceForm />
          )
        )
        .exhaustive()}
    </>
  )
}
